/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import styles from './PractitionerNote.module.scss';

import { SectionShell } from '../../atoms/SectionShell/SectionShell';
import type { PractitionerNoteProps } from './PractitionerNote.types';

export const PractitionerNote = ({ topic, className }: PractitionerNoteProps) => {
  const { t } = useInt();

  if (!topic.practitioner_note?.trim()) {
    return null;
  }

  const paragraphs = topic.practitioner_note.split('\n\n');

  return (
    <SectionShell id="practitioner-view" title={t('A note from practice')} tone="muted" className={className}>
      <blockquote className={styles['note']}>
        {paragraphs.map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </blockquote>
    </SectionShell>
  );
};
